import { MaskInput, Mask } from 'maska'

const maskList = new WeakMap()

const init = MaskInput.prototype.init
MaskInput.prototype.init = function (elements, options) {
  for (const el of elements) {
    el.addEventListener('input', e => {
      if (e.isTrusted) {
        // Событие input дублируется из-за маски, отключаем настоящее событие
        e.stopPropagation()
        this.inputEvent(e)
      }
    }, { capture: true })
  }
  init.call(this, elements, options)
}

export default {
  inserted (el, { value }) {
    if (!value) return
    const options = typeof value === 'string'
      ? { mask: value }
      : {
          mask: value.mask,
          reversed: value.reversed,
          onMaska: value.onMask,
          preProcess: value.preProcess,
          postProcess: value.postProcess
        }
    const mask = new MaskInput(el, options)
    maskList.set(el, mask)
  },
  update (el) {
    const mask = maskList.get(el)
    if (!mask) return
    const newMask = new Mask({ mask: mask.options.mask })
    if (newMask.masked(el.value) === el.value) return
    mask.setMaskedValue(el, el.value)
  },
  unbind (el) {
    const mask = maskList.get(el)
    mask?.destroy()
  }
}
